import { PharmacyInfo } from '@phx/myphx-lib';

import { useMedicationConfigOverride } from '../../contexts/DrugProgramProvider';
import type {
    ChainProviderInfoFragment,
    MailOrderProviderInfoFragment,
    PharmacyProviderInfoFragment,
    UnknownProviderInfoFragment,
} from '../../graphql/generated/graphql';
import { processProviderToPharmacyInfo } from '../../util/pharmacy/process-providers';

export const ProviderInfo = ({
    provider,
}: {
    provider:
        | ChainProviderInfoFragment
        | PharmacyProviderInfoFragment
        | MailOrderProviderInfoFragment
        | UnknownProviderInfoFragment;
}) => {
    const configOverride = useMedicationConfigOverride();
    const providerInfo = processProviderToPharmacyInfo(
        provider,
        configOverride
    );

    return <PharmacyInfo showAfterShipmentText={false} {...providerInfo} />;
};
